import { useEffect, useState } from 'react';
import type { ConsumerWireInstructionsModel } from './failed-payments.types';

type ApiClient = {
  get: <T>(url: string) => Promise<T>;
};

export function useWireInstructions({
  apiClient,
  enabled,
  homeUniqueId,
}: {
  apiClient: ApiClient;
  enabled: boolean;
  homeUniqueId?: string | null;
}) {
  const [instructions, setInstructions] =
    useState<ConsumerWireInstructionsModel | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || instructions) return;
    let cancelled = false;
    setLoading(true);
    setError(false);

    (async () => {
      try {
        const query = homeUniqueId
          ? `?homeUniqueId=${encodeURIComponent(homeUniqueId)}`
          : '';
        const response = await apiClient.get<ConsumerWireInstructionsModel>(
          `/v2/users/failed-payments/wire-instructions${query}`,
        );
        if (!cancelled) {
          setInstructions(response);
          setLoading(false);
        }
      } catch {
        if (!cancelled) {
          setError(true);
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [apiClient, enabled, homeUniqueId, instructions]);

  return { instructions, loading, error };
}
